import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useSEO } from "@/hooks/use-seo";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe, TrendingUp
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo14 from "@assets/logos_extracted/14.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://cadw.monvaki.com/?mid=282906_1667064";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Barevné a veselé rozhraní s přátelským maskotem vytváří pozitivní herní prostředí",
  "Široká nabídka uvítacích bonusů rozdělená na více částí",
  "Atraktivní věrnostní program s body a výzvami",
  "Každodenní turnaje a dostupnost sportovní sekce",
  "Více než 100 poskytovatelů her",
];

const cons = [
  "Chybí mobilní aplikace",
  "Některé informace o limitech výběrů nejsou snadno dohledatelné",
  "Design může působit lehce přeplácaně pro hráče hledající minimalistické rozhraní",
];

const categoryRatings = [
  { cat: "Výherní automaty",       strength: "Velmi široká",         rtp: "96–97 %",  innovation: "Vysoká",         load: "Střední",            score: "9/10",   color: "text-green-600" },
  { cat: "Jackpotové sloty",       strength: "Slušná",               rtp: "Různé",    innovation: "Střední",        load: "Střední",            score: "7.5/10", color: "text-yellow-600" },
  { cat: "Stolní RNG hry",         strength: "Solidní",              rtp: "Viz pravidla", innovation: "Nízká",      load: "Rychlá",             score: "8/10",   color: "text-blue-600" },
  { cat: "Live kasino",            strength: "Výrazná",              rtp: "N/A",      innovation: "Střední–vysoká", load: "Většinou rychlá",    score: "8.5/10", color: "text-green-600" },
  { cat: "\u201eGame show\u201c live tituly", strength: "Rostoucí",  rtp: "N/A",      innovation: "Vysoká",         load: "Dobrá",              score: "8/10",   color: "text-blue-600" },
  { cat: "Mobilní hraní",          strength: "Plnohodnotné",         rtp: "N/A",      innovation: "N/A",            load: "Dobrá",              score: "8/10",   color: "text-blue-600" },
  { cat: "Stabilita a výkon",      strength: "Proměnlivá",           rtp: "N/A",      innovation: "N/A",            load: "Kolísavá u špiček",  score: "7/10",   color: "text-orange-600" },
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>Do 3 dnů (e-peněženky a krypto rychleji)</span></div>
        <div className={rowClass}><span className={labelClass}>Metody vkladu:</span><span className={valueClass}>Visa, Mastercard, Skrill, Neteller, Paysafecard, Jeton, MiFinity, USDT, Bitcoin, Ethereum a další</span></div>
        <div className={rowClass}><span className={labelClass}>Metody výběru:</span><span className={valueClass}>Visa, Mastercard, bankovní převod, Revolut, Skrill, Neteller, Jeton, MiFinity, kryptoměny</span></div>
        <div className={rowClass}><span className={labelClass}>Poplatky:</span><span className={valueClass}>Standardně žádné; záleží na zprostředkovateli</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 9 000 titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Výherní automaty:</span><span className={valueClass}>Klasické, video sloty, jackpoty, book série, cluster pays, multiway</span></div>
        <div className={rowClass}><span className={labelClass}>Stolní hry:</span><span className={valueClass}>Ruleta, blackjack, baccarat, poker, video poker, stírací losy</span></div>
        <div className={rowClass}><span className={labelClass}>Live kasino:</span><span className={valueClass}>Ruleta, blackjack, baccarat, poker, Crazy Time, Mega Wheel, Bonus Wheel</span></div>
        <div className={rowClass}><span className={labelClass}>Demo verze:</span><span className={valueClass}>Ano – k dispozici u velké části katalogu</span></div>
        <div className={rowClass}><span className={labelClass}>Počet poskytovatelů:</span><span className={valueClass}>100+</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Yggdrasil, Play'n GO, Pragmatic Play, Microgaming, Evolution a další</span></div>
        <div className={rowClass}><span className={labelClass}>RTP automatů:</span><span className={valueClass}>Často 96–97 % u známých titulů</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Ano – 24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@cadoola.com</span></div>
        <div className={rowClass}><span className={labelClass}>Telefonická podpora:</span><span className={valueClass}>Ne</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky podpory:</span><span className={valueClass}>EN, DE, ES, FI, FR, HU, NO, PL, PT, IT, CS a další</span></div>
        <div className={rowClass}><span className={labelClass}>Hráčské zkušenosti:</span><span className={valueClass}>Smíšené – část chválí rychlost, jiní hlásí prodlevy</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2017</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Stellar Ltd</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan (Curacao)</span></div>
        <div className={rowClass}><span className={labelClass}>SSL šifrování:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Certifikovaný RNG:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Mobilní hraní:</span><span className={valueClass}>Responzivní web – bez aplikace</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky webu:</span><span className={valueClass}>EN, DE, ES, FI, FR, HU, NO, PL, PT, IT, CS a další</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        {([
          ["Deposit limity:", "Denní/týdenní/měsíční nastavení v profilu"],
          ["Sebevyloučení:", "Ano"],
          ["KYC ověření:", "Povinné před výběrem – připravte si doklady hned po registraci"],
          ["Věková hranice:", "18+"],
        ] as [string, string][]).map(([label, value]) => (
          <div key={label} className={rowClass}>
            <span className={labelClass}>{label}</span>
            <span className={valueClass}>{value}</span>
          </div>
        ))}
      </div>
    );
  }
  return null;
}

export default function CadoolaPage() {
  useSEO({ title: "Cadoola Casino Recenze 2026 – Licence MGA a bonus | HrajBonus", description: "Nezávislá recenze Cadoola Casino. Atraktivní uvítací bonus, rozsáhlý výběr her a spolehlivé výplaty. Licence MGA. Hodnocení 8.4/10. 18+",
  url: "https://hrajbonus.com/kasina/cadoola", });

  const [activeTab, setActiveTab] = useState("hry");

  return (
    <>
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo14} alt="Cadoola Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Cadoola</h1>
                    <div className="text-white/50 text-xs mt-0.5">Aktualizováno: 15/02/2026</div>
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5,6,7].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "80%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">7.8</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",          value: "9 000+" },
                    { label: "Minimální vklad",    value: "250 Kč" },
                    { label: "Minimální výběr",    value: "250 Kč" },
                    { label: "Poskytovatelé",      value: "100+" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Demo verze zdarma</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">RTP 96–97 %</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">100+ poskytovatelů</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Wager 35×</span>
                </div>
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 free spinů</div>
                  <div className="text-white/50 text-xs mt-1">Wager bonus 35× · Wager FS 40×</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Cadoola" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              {/* Author opinion */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-opinion">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900 text-sm">Mykhailo Romaenko</div>
                    <div className="text-gray-400 text-xs">Senior Content Writer</div>
                  </div>
                  <div className="ml-auto text-right">
                    <div className="text-[#003da5] font-black text-xl">7.8</div>
                    <div className="text-gray-400 text-xs">/10 hodnocení</div>
                  </div>
                </div>
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze na Cadoola Casino: hodnocení her</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Cadoola si vybudovala pověst místa, kde se nešetří na výběru her, ale zároveň se drží jednoduchého a svižného ovládání. Pokud vás primárně zajímá kvalita herní nabídky, stabilita platformy a reálné hráčské dojmy, následující přehled jde přímo k věci.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* Game catalog */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Herní katalog v praxi: rozsah, struktura a realita</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cadoola staví na širokém portfoliu. Po přihlášení okamžitě uvidíte stovky až tisíce výherních automatů, solidní sadu stolních a karetních klasik a výraznou sekci živého kasina. Celkový součet titulů jde do tisíců, což je na první pohled největší tahák.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-5">
                  {[
                    {
                      title: "Výherní automaty",
                      items: ["Klasické tříválce", "Moderní video sloty", "Jackpotové kusy", "\u201eBook\u201c série", "Cluster pays", "Multiway varianty"],
                    },
                    {
                      title: "Stolní a karetní hry",
                      items: ["Ruleta", "Blackjack", "Baccarat", "Poker", "Video poker", "Stírací losy"],
                    },
                    {
                      title: "Live kasino",
                      items: ["Živá ruleta", "Blackjack", "Baccarat", "Pokerové formáty", "Crazy Time", "Mega Wheel / Bonus Wheel"],
                    },
                  ].map(({ title, items }) => (
                    <div key={title} className="bg-[#f3f6fb] rounded-xl p-4">
                      <div className="font-bold text-gray-900 text-sm mb-2">{title}</div>
                      <ul className="space-y-1">
                        {items.map(item => (
                          <li key={item} className="flex items-center gap-1.5 text-gray-600 text-xs">
                            <CheckCircle className="w-3 h-3 text-[#003da5] flex-shrink-0" /> {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <p className="text-green-700 text-sm leading-relaxed">
                    <strong>Demoverze:</strong> Filtry podle poskytovatelů i typů her pomáhají v orientaci a nezřídka objevíte i demoverze, které dovolí vyzkoušet hru bez rizika. To je velká výhoda pro každého, kdo si chce otestovat volatilitu, tempo nebo bonusové mechaniky.
                  </p>
                </div>
              </div>

              {/* RTP & quality */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Kvalita automatů a RTP: kde Cadoola svítí nejvíc</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Silnou stránkou jsou automaty od zavedených studií. Mezi podporovanými tvůrci najdete rozpoznatelné značky typu NetEnt, Yggdrasil, Play'n GO, Pragmatic Play, Microgaming nebo Evolution pro live část. To v praxi znamená:
                </p>
                <div className="space-y-2 mb-4">
                  {[
                    "Nalezete široké rozpětí volatility, od \u201epohodových\u201c slotů až po vysoce riskantní hity",
                    "Průměrná návratnost k hráčům se u řady známých titulů pohybuje kolem 96 až 97 procent",
                    "Nechybí sticky wilds, expanding symboly, hold-and-spin, multiplikátory, koupené feature bonusy, Free Spins s různými modifikátory",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <TrendingUp className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                    </div>
                  ))}
                </div>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
                  <p className="text-amber-700 text-xs leading-relaxed">
                    RTP je sice pouze dlouhodobé teoretické číslo, ale jako vodítko pro výběr funguje spolehlivě. Hráči, kteří si dají práci s filtrováním nebo vyhledáváním her s vyšším nastavením, získají objektivní výhodu v podobě lepší očekávané návratnosti.
                  </p>
                </div>
              </div>

              {/* Category ratings table */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hodnocení her podle kategorií</h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Níže najdete souhrnnou tabulku zaměřenou přímo na nabídku a kvalitu her. Jde o praktické srovnání toho, co hráč skutečně potká, nikoli laboratorní test.
                </p>
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm min-w-[560px]">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Kategorie</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Síla nabídky</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">RTP</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Inovace</th>
                        <th className="text-left px-4 py-2.5 text-xs font-bold text-gray-700">Načítání</th>
                        <th className="text-right px-4 py-2.5 text-xs font-bold text-[#003da5]">Hodnocení</th>
                      </tr>
                    </thead>
                    <tbody>
                      {categoryRatings.map((row, i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-2.5 font-semibold text-gray-800 text-xs whitespace-nowrap">{row.cat}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{row.strength}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{row.rtp}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{row.innovation}</td>
                          <td className="px-4 py-2.5 text-gray-600 text-xs">{row.load}</td>
                          <td className={`px-4 py-2.5 text-xs font-black text-right ${row.color}`}>{row.score}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-gray-400 text-xs mt-2 leading-relaxed">
                  Poznámka: RTP udávají samotní poskytovatelé a může se lišit podle konkrétní verze titulu. Live hry RTP obvykle neuvádějí ve stejné formě jako sloty, řídí se matematickými pravidly dané hry.
                </p>
              </div>

              {/* Live casino */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Živé kasino a stolní klasiky: proud v HD a přátelské limity</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Live sekce je vizuálně silná. Streamy běží ve vysoké kvalitě, stoly jsou přehledné a lobby zvládá rychlé přepínání mezi hrami.
                </p>
                <div className="grid sm:grid-cols-3 gap-3 mb-4">
                  {[
                    "Klasická i variantní ruleta",
                    "Blackjack s běžnými i vyššími limity",
                    "Baccarat a pokerové formáty",
                    "Suverénní obraz i zvuk",
                    "Stabilita lobby",
                    "Různé velikosti sázek pro každého",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-xs leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Pro zkušené stolní hráče je k dispozici i dostatek RNG verzí rulety nebo blackjacku. Ty běží bez dealera a jsou vhodné pro rychlejší tempo nebo krátké session.
                </p>
              </div>

              {/* UX & Mobile */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-2">Uživatelská zkušenost a mobilní hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Rozhraní Cadoola působí svěže a přehledně. Navigace je intuitivní, filtry a vyhledávání fungují spolehlivě a v češtině se orientuje velmi snadno.
                </p>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    "Okamžitá dostupnost demoverzí u velké části katalogu",
                    "Rychlé přepínání mezi kategoriemi a poskytovateli",
                    "Účty, limity a ověřování na jednom místě, bez zbytečného klikání",
                    "Mobilní web bez potřeby stahovat aplikaci",
                    "Filtrování funguje použitelně i na menším displeji",
                    "Live stoly drží kvalitu i přes mobilní data",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-1.5 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                    </div>
                  ))}
                </div>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
                  <p className="text-amber-700 text-xs leading-relaxed">
                    Občas se v recenzích objevují dvě výtky: zpomalení při náhodném procházení lobby a prodleva při nahrávání některých her. Pokud vás trápí načítání, pomůže přepnout na Wi-Fi a ukončit procesy běžící na pozadí.
                  </p>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy a protočení: velká lákadla, přísnější pravidla</h2>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4 mb-5">
                  <div className="text-[#003da5] font-black text-xl mb-0.5">100% bonus k prvnímu vkladu</div>
                  <div className="text-[#c9960f] font-bold text-base mb-1">maximálně 12 500 Kč + 200 free spinů</div>
                  <div className="text-gray-500 text-xs">Wager bonus 35× · Wager FS 40× · Minimální vklad 250 Kč</div>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Promo nabídky patří k silným stránkám. Uvítací balíčky, týdenní i víkendové akce, cashback a občasné \u201emini hry\u201c typu Bonus Crab pomáhají udržet herní rozpočet déle v akci. Hráči často zmiňují i narozeninové odměny nebo věrnostní prvky pro stálé účty.
                </p>
                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4">
                  <div className="font-bold text-amber-800 text-sm mb-2">Podmínky jsou náročnější – co je třeba mít na paměti:</div>
                  <ul className="space-y-1">
                    {[
                      "Protočení hotovostních bonusů bývá nastavené výš",
                      "Výhry z free spinů mají samostatné multiplikátory protočení",
                      "Některé platební metody mohou být z promo akcí vyloučené",
                      "Časová okna pro splnění požadavků nebývají dlouhá",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-1.5 text-amber-700 text-sm">
                        <AlertTriangle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" /> {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-green-50 border border-green-200 rounded-xl p-3">
                  <p className="text-green-700 text-xs leading-relaxed">
                    <strong>Tip:</strong> čtěte pravidla přímo v profilu promoakce ještě před aktivací, včetně omezení sázek na roztočení nebo konkrétních her vyjmutých z protočení. Vyhnete se zbytečným nedorozuměním.
                  </p>
                </div>
              </div>

              {/* How to choose a game */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Jak si vybrat správnou hru v Cadoola</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Výběrem správného titulu zvednete šance na spokojenou session. Nemusí jít o honbu za jackpotem, často stačí dobrý match mezi vámi a matematikou hry.
                </p>
                <ul className="space-y-2 mb-5">
                  {[
                    "Filtrujte podle poskytovatele, kterému věříte a jehož styl vám sedí",
                    "Hledejte verze s vyšším RTP, pokud jsou k dispozici",
                    "Preferujte volatility, které odpovídají rozpočtu a délce hraní",
                    "Vyzkoušejte demoverzi a sledujte tempo i frekvenci zásahů",
                    "Sledujte pravidla bonusových funkcí, hlavně multiplikátory a retriggery",
                    "U stolních her si projděte pravidla varianty – třeba u blackjacku mohou rozhodovat drobnosti",
                  ].map(item => (
                    <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <span className="text-[#003da5] font-bold mt-0.5 flex-shrink-0">→</span> {item}
                    </li>
                  ))}
                </ul>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-3">
                  <p className="text-[#003da5] text-xs font-medium leading-relaxed">
                    Krátký rituál před začátkem: nastavte si limit na session, určete si hranici výhry i ztráty a dodržte je. Tohle je nejjednodušší hack pro dlouhodobě příjemný zážitek.
                  </p>
                </div>
              </div>

              {/* Payments */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platby, výběry a ověřování</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Platební metody pokrývají to, na co jsou online hráči zvyklí: platební karty, e-peněženky, bankovní převody i kryptoměny. Pozitivní je šíře volby a fakt, že vklady probíhají svižně.
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-4">
                  {[
                    { label: "Min. vklad",    value: "250 Kč" },
                    { label: "Min. výběr",    value: "250 Kč" },
                    { label: "Rychlost",      value: "Do 3 dnů" },
                    { label: "Nejrychlejší", value: "E-peněženky / krypto" },
                    { label: "Nejpomalejší", value: "Bankovní převod" },
                    { label: "Poplatky",      value: "Standardně žádné" },
                  ].map(({ label, value }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-900 font-bold text-xs">{value}</div>
                    </div>
                  ))}
                </div>
                <div className="space-y-1.5">
                  {[
                    "KYC dokumenty si připravte hned po registraci",
                    "Pro rychlost se osvědčují e-peněženky nebo kryptoměny",
                    "Bankovní převod bývá nejpomalejší",
                    "U výběrů záleží hodně na zvoleté metodě a stavu ověření účtu",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-1.5 text-gray-600 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" /> {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Security */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost a licence</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Cadoola běží pod licencí Curacao, používá šifrování SSL a hry pracují s certifikovaným generátorem náhodných čísel. To jsou tři pilíře technické důvěryhodnosti. Pro hráče z Česka je podstatná informace, že nejde o licenci vydanou českým regulátorem. Právní ochrana je tedy jiná, než na co jste zvyklí u lokálně licencovaných subjektů.
                </p>
                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3 mb-4">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Cadoola funguje na základě licence Anjouan (Curacao). Nejde o licenci vydanou Ministerstvem financí ČR, což znamená nižší právní ochranu pro české hráče oproti lokálně regulovaným operátorům.
                  </p>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Praktické doporučení: držet rozpočet na uzdě, nastavit si limity vkladu a času, ověřit účet včas a hrát jen to, co opravdu chcete hrát. Férovost mechanik je dána poskytovateli her a RNG, ale disciplína bankrollu je čistě na vás.
                </p>
              </div>

              {/* Who is Cadoola for */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Pro koho je Cadoola dobrou volbou</h2>
                <div className="grid sm:grid-cols-2 gap-3 mb-5">
                  {[
                    { title: "Pro vás", items: [
                      "Milovníci slotů – procházení velkých katalogů a zkoušení novinek",
                      "Hráči živých stolů – kvalitní stream, přátelské limity",
                      "Mobilní hráči – bez instalace, pohodlně v prohlížeči",
                      "Zájemci o promo programy a cashback (pečlivě čtěte podmínky)",
                    ]},
                    { title: "Zvažte alternativy", items: [
                      "Vyžadujete extrémní rychlost výplat za všech okolností",
                      "Hledáte minimalistický design bez přeplácení",
                      "Preferujete mobilní aplikaci ke stažení",
                    ]},
                  ].map(({ title, items }) => (
                    <div key={title} className={`rounded-xl p-4 ${title === "Pro vás" ? "bg-green-50 border border-green-200" : "bg-[#f3f6fb] border border-[#dde4ee]"}`}>
                      <div className={`font-bold text-sm mb-2 ${title === "Pro vás" ? "text-green-800" : "text-gray-700"}`}>{title}</div>
                      <ul className="space-y-1.5">
                        {items.map(item => (
                          <li key={item} className={`flex items-start gap-1.5 text-xs ${title === "Pro vás" ? "text-green-700" : "text-gray-600"}`}>
                            {title === "Pro vás"
                              ? <CheckCircle className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                              : <span className="mt-0.5 flex-shrink-0">▬</span>}
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* Support */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Hráčské ohlasy na podporu jsou smíšené. Část uživatelů chválí konkrétní operátory na chatu a rychlé vyřešení drobných zádrhelů, jiní popisují zdlouhavé reakce, případně opakované žádosti o dokumenty.
                </p>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7 dostupný</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@cadoola.com</div>
                    </div>
                  </div>
                </div>
                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-xs mb-2">Jak na hladší průběh komunikace:</div>
                  <ul className="space-y-1">
                    {[
                      "Mějte připravené jasné screenshoty a faktury k ověření plateb",
                      "Komunikujte přes chat a shrnujte si závěry konverzace do vlastních poznámek",
                      "Držte se faktů, buďte věcní a pečlivě čtěte instrukce",
                    ].map(item => (
                      <li key={item} className="text-gray-600 text-xs flex items-start gap-1.5">
                        <span className="text-[#003da5] font-bold flex-shrink-0">→</span> {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              {/* FAQ */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Nejčastější otázky k herní nabídce</h2>
                <div className="space-y-4">
                  {[
                    { q: "Lze hrát zdarma?", a: "Ano, mnoho slotů nabízí demo režim, který se hodí před sázkami za reálné peníze." },
                    { q: "Jaké poskytovatele tady najdu?", a: "Široké spektrum včetně NetEnt, Yggdrasil, Play'n GO, Pragmatic Play a Evolution pro live hry. Celkem více než 100 studií." },
                    { q: "Jak si ohlídat RTP?", a: "U některých titulů je zobrazené přímo v informacích hry. Obecně se zaměřte na známé verze s tradičně vyšší návratností." },
                    { q: "Má smysl \u201egame show\u201c v live sekci?", a: "Pokud vás baví interakce a bonusová kola, rozhodně. Základní návratnost je daná pravidly, ale zábavnost je vysoká." },
                    { q: "Mohu hrát na mobilu bez aplikace?", a: "Ano. Mobilní web běží přímo v prohlížeči a je použitelný i pro delší hraní." },
                  ].map(({ q, a }) => (
                    <div key={q} className="border-b border-[#eef1f7] pb-4 last:border-0 last:pb-0">
                      <div className="font-semibold text-gray-900 text-sm mb-1.5">{q}</div>
                      <div className="text-gray-600 text-sm leading-relaxed">{a}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Summary */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Závěr</h2>
                <p className="text-gray-600 leading-relaxed">
                  Cadoola sází na šíři a moderní pojetí. Herní nabídka je silná, live část vypadá výborně a mobilní varianta je praktická. Kdo jde do hry s rozumnými očekáváními a vnímá pravidla promo nabídek, získá pestrý a zábavný katalog, ke kterému se bude rád vracet.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-[#003da5]/10"><img src={mykhailoPhoto} alt="Mykhailo Romaenko" className="w-full h-full object-cover" /></div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo14} alt="Cadoola" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Cadoola Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4,5,6,7].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "80%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">7.8/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 free spinů</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× bonus · 40× FS</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,    label: "Rok",             value: "2017" },
                      { icon: Globe,       label: "Provozovatel",    value: "Stellar Ltd" },
                      { icon: Lock,        label: "Licence",         value: "Anjouan (Curacao)" },
                      { icon: Gamepad2,    label: "Počet her",       value: "9 000+" },
                      { icon: Users,       label: "Poskytovatelé",   value: "100+" },
                      { icon: CreditCard,  label: "Min. vklad",      value: "250 Kč" },
                      { icon: Zap,         label: "Výplaty",         value: "Do 3 dnů" },
                      { icon: Trophy,      label: "Demo verze",      value: "Ano – zdarma" },
                      { icon: TrendingUp,  label: "Průměrné RTP",    value: "96–97 % (automaty)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Začněte s demem</div>
                  <p className="text-[#003da5]/80 text-xs leading-relaxed">
                    Začněte s demem u 3–5 slotů, které vás zaujmou tématem a mechanikou. Až potom přejděte na malé sázky v reálné hře.
                  </p>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="cadoola" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/legiano" className="text-[#003da5] hover:underline" data-testid="review-link-legiano">Legiano</a>
              {" · "}
              <a href="/kasina/librabet" className="text-[#003da5] hover:underline" data-testid="review-link-librabet">Librabet</a>
              {" · "}
              <a href="/kasina/boaboa" className="text-[#003da5] hover:underline" data-testid="review-link-boaboa">Boaboa</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
